import { useAppDispatch } from "../../../store/hooks/StoreHooks"
import { clearNozzleAndThroat, getNozzleArea, getThroatArea, setDarcey, setGasVent, setJetPumpSize, setManufacturerId, setManufacturerName, setMaxPowerFLuidPressure, setMinPowerFluidPressure, setNozzleAreaSize, setNozzleDiameterSize, setNozzleValue, setOutputPressure, setPowerFluidDensity, setPowerFluidType, setSelectedChargePumpSize, setSelectedPlungerSize, setSelectedSurfacePumpSize, setSelectedVesselSize, setStepFluidRange, setTangent, setThroatAreaSize, setThroatDiameterSize, setThroatValue } from "../../../store/jetlift/jetlift-input/JetPumpSlice";

const useJetPumpFacade = () => {
    const dispatch = useAppDispatch();

    const updateManufacturerId = (payload: any) => {
        return dispatch(setManufacturerId(payload));
    };

    const updateManufacturerName = (payload: any) => {
        return dispatch(setManufacturerName(payload));
    };

    const updateMinPowerFluidPressure = (payload: string | number) => {
        return dispatch(setMinPowerFluidPressure(payload));
    };

    const updateMaxPowerFluidPressure = (payload: string | number) => {
        return dispatch(setMaxPowerFLuidPressure(payload));
    };

    const updateStepFluidRange = (payload: string | number) => {
        return dispatch(setStepFluidRange(payload));
    };

    const updateNozzleDiameterSize = (payload: string) => {
        return dispatch(setNozzleDiameterSize(payload));
    };

    const updateNozzleAreaSize = (payload: string | number) => {
        return dispatch(setNozzleAreaSize(payload));
    };

    const updateNozzleValue = (payload: number) => {
        return dispatch(setNozzleValue(payload));
    };

    const updateThroatDiameterSize = (payload: string) => {
        return dispatch(setThroatDiameterSize(payload));
    };

    const updateThroatAreaSize = (payload: string | number) => {
        return dispatch(setThroatAreaSize(payload));
    };
    
    const updateThroatValue = (payload: number) => {
        return dispatch(setThroatValue(payload));
    };

    const updatePowerFluidType = (payload: string) => {
        return dispatch(setPowerFluidType(payload));
    };

    const updatePowerFluidDensity = (payload: number) => {
        return dispatch(setPowerFluidDensity(payload));
    };

    const updateOutputPressure = (payload: string) => {
        return dispatch(setOutputPressure(payload));
    };

    const updateGasVent = (payload: string) => {
        return dispatch(setGasVent(payload));
    };

    const updateTangent = (payload: string) => {
        return dispatch(setTangent(payload));
    };
    
    const updateDarcey = (payload: string) => {
        return dispatch(setDarcey(payload));
    };

    const updateSelectedVesselSize = (payload: string) => {
        return dispatch(setSelectedVesselSize(payload));
    };

    const updateSelectedChargePumpSize = (payload: string) => {
        return dispatch(setSelectedChargePumpSize(payload));
    };

    const updateSelectedSurfacePumpSize = (payload: string) => {
        return dispatch(setSelectedSurfacePumpSize(payload));
    };

    const updateSelectedPlungerSize = (payload: string) => {
        return dispatch(setSelectedPlungerSize(payload));
    };

    const updateJetPumpSize = (payload: any) => {
        return dispatch(setJetPumpSize(payload));
    };

    const loadNozzleArea = () => {
        return dispatch(getNozzleArea())
    };

    const loadThroatArea = () => {
        return dispatch(getThroatArea())
    };

    const clearNozzleThroat = () => {
        return dispatch(clearNozzleAndThroat());
    };

    return {
        updateManufacturerId,
        updateManufacturerName,
        updateMinPowerFluidPressure,
        updateMaxPowerFluidPressure,
        updateStepFluidRange,
        updateNozzleDiameterSize,
        updateNozzleAreaSize,
        updateNozzleValue,
        updateThroatDiameterSize,
        updateThroatAreaSize,
        updateThroatValue,
        updatePowerFluidType,
        updatePowerFluidDensity,
        updateOutputPressure,
        updateGasVent,
        updateTangent,
        updateDarcey,
        updateSelectedVesselSize,
        updateSelectedChargePumpSize,
        updateSelectedSurfacePumpSize,
        updateSelectedPlungerSize,
        updateJetPumpSize,
        loadNozzleArea,
        loadThroatArea,
        clearNozzleThroat,
    }
};

export default useJetPumpFacade;